import fpLog from "./fpLog";

export async function handleError(errDetails) {
  let { error } = errDetails;

  if (typeof error === "string") {
    error = new Error(error);
  }
  errDetails.error = error;

  errDetails = {
    errorMsg: error?.message,
    errorStack: error?.stack,
    ...errDetails,
  };

  if (error?.status) {
    if (!errDetails.errorMsg)
      errDetails.errorMsg = error.status + " " + error.statusText;
    else errDetails.errorMsg += " " + error.status + " " + error.statusText;
  }

  if (errDetails.code === "API_CALL_FAILED") {
    const { failedResponse, retries } = errDetails;
    let responseText = "";
    let responseJson = {};
    if (failedResponse) {
      try {
        responseText = await failedResponse.text();
      } catch (error) {}
      try {
        responseJson = await failedResponse.json();
      } catch (error) {}
    }

    errDetails = {
      ...errDetails,

      responseStatus: failedResponse?.status,
      responseStatusText: failedResponse?.statusText,
      responseText,
      responseJson,
      retries,
    };
  }

  errDetails.logType = "ERROR";

  if (window.location.hostname.includes("localhost")) {
    console.error(error);
  } else fpLog(errDetails);
}
